export const handleAudioTextInput = (Contentdata) => {
  if (Contentdata.type === "header") {
    return function (event) {
      let prompt_content = event.target.innerText;
      Contentdata.quizdata.prompt_content.content = prompt_content;
    };
  }
  else {
    return function (event) {
      let audio_text = event.target.innerText;
      Contentdata.quizdata.audio_text = audio_text;
    };
  }
};

export const handleHeaderInput = (Contentdata) => {
  if (Contentdata.type === "header") {
    return function (event) {
      let prompt_content = event.target.innerText;
      Contentdata.quizdata.prompt_content = prompt_content;
    };
  }
  else if (Contentdata.type === "time_allowed") {
    return function (event) {
      let recom_time = event.target.innerText;
      Contentdata.quizdata.recom_time = parseInt(recom_time);
    };
  } else {
    return function (event) {
      let html_content = event.target.innerHTML;
      Contentdata.quizdata.html_content = html_content;
    };
  }
};

export const handleQuestionInput = (Contentdata) => {
  if (Contentdata.type === "question") {
      let prompt_content;
      let target;
      const editQuestions = document.querySelectorAll('.editquestions');
      const removeSavebtn = document.getElementById("edit_btn");
      const elementToRemove = document.getElementsByClassName("contentremove");
      const placeholders = document.getElementsByClassName("data_id");
      const editableSpans = document.querySelectorAll('.editable');
      target = editQuestions[Contentdata.key].innerHTML
      if (target !== editableSpans[Contentdata.key].innerHTML)
      {
        editableSpans.forEach((spanelement) => {
          target = target.replace(spanelement.outerHTML, spanelement.textContent)
        });
      }
      if (elementToRemove.length > 0 && placeholders.length > 0)
      {
        for (var i = 0; i < elementToRemove.length; i++) {
          if (target.includes(elementToRemove[i].outerHTML)) {
            let placeholder = placeholders[i].innerText;
            if (prompt_content) {
              prompt_content = prompt_content.replace(
                elementToRemove[i].outerHTML,
                placeholder
              );
            } else {
              prompt_content = target.replace(
                elementToRemove[i].outerHTML,
                placeholder
              );
            }
          }
        }
      }
      else{
        prompt_content = target;
      }
      if (prompt_content && prompt_content.includes(removeSavebtn.outerHTML))
      {
        prompt_content = prompt_content.replace(
          removeSavebtn.outerHTML,
          ""
        );
      }
      if(prompt_content){
        Contentdata.quizdata.questions[Contentdata.key].prompt_content = prompt_content;
      }
  }
};
export const handleAnswersInput = (Contentdata) => {
      return function (event) {
        let answer_prompt_content = event.target.innerText;
        Contentdata.quizdata.questions[Contentdata.ques_key].possible_answers[Contentdata.ans_key].prompt_content = answer_prompt_content;
      };
  };

export  const EditableContentCreate = () => {
    if(document.querySelectorAll('.editable').length > 0)
    {
      const editableElements = document.querySelectorAll('.editable');
      editableElements.forEach(element => {
        element.contentEditable = 'true';
      });
    }
    else{
      const editQuestions = document.querySelectorAll('.editquestions');
      Array.from(editQuestions).forEach(spanTag => {
        Array.from(spanTag.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            CreateSpanElement(node);
          }
          else if(node.childNodes && !node.className.includes("contentremove")) {
            Array.from(node.childNodes).forEach(node => {
              if (node.nodeType === Node.TEXT_NODE) {
                CreateSpanElement(node);
              }
              else if(node.childNodes && !node.className.includes("contentremove")) {
                Array.from(node.childNodes).forEach(node => {
                  if (node.nodeType === Node.TEXT_NODE ) {
                    CreateSpanElement(node);
                  }
                  else if(node.childNodes && !node.className.includes("contentremove")) {
                    Array.from(node.childNodes).forEach(node => {
                      if (node.nodeType === Node.TEXT_NODE ) {
                        CreateSpanElement(node);
                      }
                      else if(node.childNodes) {
                        Array.from(node.childNodes).forEach(node => {
                          if (node.nodeType === Node.TEXT_NODE ) {
                            CreateSpanElement(node);
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      })
    }
};

const CreateSpanElement = (node) => {
  const wrapper = document.createElement('span');
  wrapper.contentEditable = 'true';
  wrapper.setAttribute('spellCheck', 'false');
  wrapper.setAttribute('data-gramm', 'false');
  wrapper.className = 'editable';
  wrapper.textContent = node.textContent;
  node.replaceWith(wrapper);
}

export const handleMaterialInput = (Contentdata) => {
  if (Contentdata.type === "header") {
    return function (event) {
      let prompt_content = event.target.innerText;
      Contentdata.materialdata.title = prompt_content;
    };
  }
  else {
    return function (event) {
      let html_content = event.target.innerHTML;
      Contentdata.materialdata.output_prompt_content = html_content;
    };
  }
};